// City slugs used for local SEO landing pages (sync with Django CITY_LOCATIONS)
export const CITY_SLUGS = new Set([
  'ahmedabad', 'surat', 'vadodara', 'bhavnagar', 'kutch', 'himmatnagar', 'vatva',
  'kathwada', 'kalol', 'gandhidham', 'mehsana', 'chhatral', 'pune', 'bangalore',
  'mangalore', 'mumbai', 'hyderabad', 'chennai', 'noida', 'bhopal', 'faridabad',
  'indore', 'rohtak', 'ambala', 'gurugram', 'jaipur', 'udaipur', 'delhi', 'gujarat',
  'maharashtra', 'rajasthan', 'pan-india',
]);

export const CITY_NAMES = {
  "ahmedabad":   "Ahmedabad",
  "surat":       "Surat",
  "vadodara":    "Vadodara",
  "bhavnagar":   "Bhavnagar",
  "kutch":       "Kutch",
  "himmatnagar": "Himmatnagar",
  "vatva":       "Vatva",
  "kathwada":    "Kathwada",
  "kalol":       "Kalol",
  "gandhidham":  "Gandhidham",
  "mehsana":     "Mehsana",
  "chhatral":    "Chhatral",
  "pune":        "Pune",
  "bangalore":   "Bangalore",
  "mangalore":   "Mangalore",
  "mumbai":      "Mumbai",
  "hyderabad":   "Hyderabad",
  "chennai":     "Chennai",
  "noida":       "Noida",
  "bhopal":      "Bhopal",
  "faridabad":   "Faridabad",
  "indore":      "Indore",
  "rohtak":      "Rohtak",
  "ambala":      "Ambala",
  "gurugram":    "Gurugram",
  "jaipur":      "Jaipur",
  "udaipur":     "Udaipur",
  "delhi":       "Delhi",
  "gujarat":     "Gujarat",
  "maharashtra": "Maharashtra",
  "rajasthan":   "Rajasthan",
  "pan-india":   "Pan India",
};

